module.exports = __webpack_public_path__ + "static/media/IMG_7603-min.b112c399.jpg";